module.exports = __webpack_public_path__ + "media/images/common/services/talkport/logo_white-732bfbc0d6cf1ebd8220233d6c5afa16.png";